import {
  RbTable,
  RbToolbarActionButton,
  RbToolbarActions,
  Tooltip,
} from "@scmlatam/web-ui";
import type { Row } from "../types/hooks";
import { useTable } from "../hooks/useTable";
import ToolbarRefreshIcon from "../../../../assets/icons/toolbar-refresh-icon.svg";
import ToolbarDeleteIcon from "../../../../assets/icons/toolbar-delete-icon.svg";

const Table = (tableProps: ReturnType<typeof useTable>) => {
  return (
    <>
      <RbTable<Row>
        className="mt-4 w-full"
        toolbarRight={
          <RbToolbarActions>
            {tableProps.canDeleteResult && (
              <Tooltip content={tableProps.t("tooltips.delete")}>
                <RbToolbarActionButton
                  variant="icon"
                  disabled={tableProps.selectedRowIds.size === 0}
                  loading={tableProps.loading}
                  onClick={() => {
                    tableProps.setOpenDeleteConfirm(true);
                  }}
                  icon={<img src={ToolbarDeleteIcon} alt="toolbar-delete-icon" />}
                />
              </Tooltip>
            )}

            <Tooltip content={tableProps.t("tooltips.reload")}>
              <RbToolbarActionButton
                variant="icon"
                loading={tableProps.loading}
                onClick={() => {
                  tableProps.search();
                }}
                icon={
                  <img src={ToolbarRefreshIcon} alt="toolbar-refresh-icon" />
                }
              />
            </Tooltip>
          </RbToolbarActions>
        }
        columns={tableProps.columns}
        rows={tableProps.rows}
        loading={tableProps.loading}
        checkboxSelection={true}
        rowSelectionModel={tableProps.rowSelected}
        setRowSelectionModel={tableProps.setRowSelected}
        density="comfortable"
        size="l"
      />
    </>
  );
};

export { Table };
